var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "legitimation-resend" },
    [
      !_vm.requestedCode
        ? [
            _vm.typeMobilePhone && _vm.changable
              ? _c("Phone", {
                  staticClass: "mb-3",
                  attrs: { meta: _vm.meta },
                  model: {
                    value: _vm.phoneNumber,
                    callback: function($$v) {
                      _vm.phoneNumber = $$v
                    },
                    expression: "phoneNumber"
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.typeMobilePhone && !_vm.changable
              ? _c("div", { staticClass: "legitimation-resend--show" }, [
                  _vm._v(_vm._s(_vm.phone.formatted))
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.typeEmail
              ? _c("div", [
                  _vm._v(
                    "\n\t\t\tWir senden dir eine E-Mail mit einem Code zur Bestätigung zu.\n\t\t"
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.typeMobilePhone
              ? _c("div", [
                  _vm._v(
                    "\n\t\t\tWir senden dir eine SMS mit einem Code zur Bestätigung zu.\n\t\t"
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "mt-3" },
              [
                _c("Button", {
                  attrs: {
                    text: "Code anfordern",
                    icon: "checkmark",
                    disabled:
                      !_vm.preCodeRequestDataValid || _vm.requestingCode,
                    loading: _vm.requestingCode
                  },
                  on: { click: _vm.requestCode }
                })
              ],
              1
            )
          ]
        : [
            _c("FormGroup", { attrs: { label: "Code" } }, [
              _c(
                "div",
                { staticClass: "d-flex align-items-center" },
                [
                  _c("b-input", {
                    staticStyle: { width: "10rem" },
                    attrs: { type: "text" },
                    on: {
                      keyup: function($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        return _vm.submitCode.apply(null, arguments)
                      }
                    },
                    model: {
                      value: _vm.code,
                      callback: function($$v) {
                        _vm.code = typeof $$v === "string" ? $$v.trim() : $$v
                      },
                      expression: "code"
                    }
                  }),
                  _vm._v(" "),
                  _c("Button", {
                    staticClass: "ml-2",
                    attrs: {
                      icon: "checkmark",
                      text: "Code bestätigen",
                      disabled: !_vm.canSubmitCode,
                      loading: _vm.submittingCode
                    },
                    on: { click: _vm.submitCode }
                  }),
                  _vm._v(" "),
                  _vm.submittingError
                    ? _c("div", { staticClass: "error ml-2" }, [
                        _vm._v("Code ungültig")
                      ])
                    : _vm._e()
                ],
                1
              )
            ])
          ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }